import { useMemo } from "react";
import { Typography } from "@maysoft/common-component-react";

import { ICodename } from "../../commons/interfaces";

interface IProps {
    value: string | number;
    language?: string;
    data?: ICodename[];
    isCodeName?: boolean;
    isMultilang?: boolean;
}

const TableCell: React.FC<IProps> = ({ value, data, isCodeName, isMultilang, language }) => {
    const renderValue = useMemo(() => {
        if (isCodeName && data.length > 0) return data.find((item) => item.code === value)?.name || "";
        return value;
    }, [value, data, isCodeName, isMultilang, language]);
    
    return (
        <Typography variant="caption" fontWeight="medium" color="text">
            {renderValue}
        </Typography>
    );
};

export default TableCell;
